// ─── Onboarding / discovery tips ──────────────────────────────────────────
// Shown to users after ~1 min and ~2 min of active time in the app (max 2/day).
// To add more: just add another object below with a unique id and a message.
// `condition` is optional — return false to skip a tip for a given user
// (ctx currently provides { isPremium }).

export const TIPS = [
  {
    id: "premium_name",
    message: "You can request a premium name from Settings — gold shimmer, sword prefix, and more.",
    condition: (ctx) => !ctx.isPremium,
  },
  {
    id: "premium_look",
    message: "Premium names glow gold and stand out in the Global Leaderboard. Request yours from Settings.",
    condition: (ctx) => !ctx.isPremium,
  },
  {
    id: "global_rank",
    message: "Check the Global Leaderboard to see where you stand against other hunters.",
  },
  {
    id: "volume",
    message: "You can adjust the app's volume from Settings.",
  },
  {
    id: "custom_xp",
    message: "Tasks feeling too easy or too hard? You can customize their XP anytime.",
  },
];
